import React from "react";
import {Checkbox, DatePicker, Input, message, Modal, Popover, Table, Tooltip} from "antd";
import {WorkOrderList} from "../../../models/workorder";
import {pagination, toList} from "../../../controller/Utils";
import {Config} from "../../../controller/Global";
import {TrackHeaderLink} from "../TrackHeaderLink";

const moment = require('moment');

const { RangePicker } = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;
const WORKORDER = 'workorder';
const MANIFEST = Config.constant.service_type.manifest;

export class Draft extends React.Component {
  state = {
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
  };

  showPrintModal = (row_id) => {
    this.setState({
      printVisible: true,
      row_id: row_id
    });
  }

  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  }


  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({loading: true, params});
    params['table'] = true;
    WorkOrderList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'created',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };


  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="Edit"><i className="fa fa-pencil" /></a>
        <a title="Move to Trash"><i className="fa fa-trash" /></a>
      </div>
    }, {
      title: 'Created Date',
      dataIndex: 'created',
      sorter: true,
      render: created => moment(created).format('YYYY-MM-DD')
    }, {
      title: 'Work Order Number',
      dataIndex: 'work_order_number',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip placement="top" title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span className="uppercase-letter">{generator.company_name}<br />ID: {generator.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      render: bill_to => <Tooltip placement="top" title={`${bill_to.address} ${bill_to.city} ${bill_to.zip_code}`}><span>{bill_to.company_name}<br /> ID: {bill_to.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
      sorter: true
    },
    {
      title: <span className="billto-column-tbl">Truck Type</span>,
      dataIndex: 'service',
      key :'truck_type',
      render: service => service.map(service => service.truck_type.map(type => type.type_name).join(', ')).join(' | '),
    },
    {
      title: 'Transporter',
      dataIndex: 'service',
      key: 'transporter',
      render: service =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.transporter.name}</p>)}
          </div>}
          title="All Transporter">
          <a type="primary">{service[0].transporter.name} <i className="fa fa-info-circle" /></a>
        </Popover>,
      sorter: true
    },
    {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service date',
      sorter: true,
      render: (service) =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.service_date}<Tooltip title={item.status}><span className={"status-services " + (item.status)}><i className="fa fa-circle" /></span></Tooltip></p>)}
          </div>} title="All Service Date">
          <a type="primary">{service[0].service_date} <i className="fa fa-info-circle" /></a>
        </Popover>
    }, {
      title: 'Status',
      dataIndex: 'service',
      sorter: false,
      render: (service) => {
        const pending = service.filter(item => item.status !== 'completed').length;
        if (!pending)
          return <Tooltip title="Completed"><span className="completed"><i className="fa fa-circle" /></span></Tooltip>;
        else if (pending !== service.length)
          return <Tooltip title="Partially"><span className="partially"><i className="fa fa-circle" /></span></Tooltip>
        else
          return <Tooltip title="Pending"><span className="pending"><i className="fa fa-circle" /></span></Tooltip>
      }
    }
  ];

  componentDidMount() {
    this.fetch();
  }

  setAddUpdateWorkOrderModel(addUpdateWorkOrderModel) {
    this.setState({ addUpdateWorkOrderModel });
  }

  setShowWorkOrderModel(showWorkOrderModel) {
    this.setState({ showWorkOrderModel });
  }

  setSelectQuoteVisible(selectQuoteVisible) {
    this.setState({ selectQuoteVisible });
  }

  setChoiceWorkOrder(setChoiceWorkOrderModel) {
    this.setState({ setChoiceWorkOrderModel })
  }

  render() {
    const {pagination, data, loading, selectedRowKeys, row_id, printBtnLoading} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return <div id="main-content">
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-sm-3 col-12">
              <h3 className="main-heading">AB Tracks</h3>
            </div>
            <div className="col-sm-9 col-12">
              <TrackHeaderLink/>
            </div>
          </div>
          <div className="row clearfix edit-header">
            <div className="col-sm-4 col-12">
              <div id="date_range_wrapper">
                <RangePicker onChange={this.onDateRangeChange} />
              </div>
            </div>
            <div className="col-sm-4 col-10 pull-xs-right">
              <Search placeholder="Input search text" onSearch={value => this.fetch({ search: value })}
                style={{ width: "100%" }} />
            </div>
            <div className="col-sm-4 col-12 edit-div">
              <span>{pagination.total} Records</span>

              <button className="btn btn-edit" title="Trash">
                <i className="fa fa-trash-o" />
              </button>
              <button type="primary" className="btn btn-edit">
                <i className="fa fa-eye" />
              </button>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-12">
              <div className="listing-table">
                <Table
                  className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                  pagination={pagination} columns={this.columns} dataSource={data} loading={loading}
                  locale={{ emptyText: 'No Work Order Available' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/draft/Draft.jsx